export enum ESignatureLevel {
  ELECTRONIC = 'ELECTRONIC', OTHER = 'OTHER', NONE = 'NONE'
}
